import { useInboxes as useInboxesFromContext } from "@/lib/contexts/ConnectionsContext";
import { useMessagesContext } from "@/lib/contexts/MessagesContext";
import type { Inbox, InboxGroup } from "@/lib/core/crm/types";

interface UseInboxesReturn {
  inboxes: Inbox[];
  groups: (InboxGroup & { inboxes: Inbox[] })[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
  totalUnreadCount: number;
}

export function useInboxes(): UseInboxesReturn {
  const { inboxes, groups, loading, error, refetch } = useInboxesFromContext();
  const { getTotalUnreadCount } = useMessagesContext();

  // fetches the actual total unread count from MessagesContext
  const totalUnreadCount = getTotalUnreadCount();

  return {
    inboxes,
    groups,
    loading,
    error,
    refetch: async () => {
      await refetch();
    },
    totalUnreadCount,
  };
}
